import {actionNames} from 'constants/index';

const mapDispatchToProps = dispatch => ({
    SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP: (step)=>  dispatch({ "type":actionNames.SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP, payload: step}),   
    CLEAR_DATA_IS_REGISTERED: ()=>  dispatch({ "type":actionNames.CLEAR_DATA_IS_REGISTERED}),   
    CLEAR_DATOS_GENERALES_DEL_CIUDADANO: ()=>  dispatch({ "type":actionNames.CLEAR_DATOS_GENERALES_DEL_CIUDADANO}),   

});
export default mapDispatchToProps;